import { Button, Typography } from "@mui/material";
import { PreAlertItem, defaultPreAlert, preAlertValidation } from "../components/PreAlertItem";
import { useCallback, useEffect, useState } from "react";

import { AddCircleOutline } from "@mui/icons-material";
import { PreAlertItemComponent } from "../components/PreAlertItemComponent";
import localisations from "../../../localisation";

type SelectItemStageProps = {
    fieldCompanyId: number;
    fields: {
        items: PreAlertItem[];
    };
    handleFieldChange: (fields: any) => void;
    onDisableNextButton?: (disable: boolean) => void;
};

interface PreAlertComponentItem {
    preAlertItem: PreAlertItem;
    isValid: boolean;
}

function SelectItemsStage(props: SelectItemStageProps) {

    //Please see ticket https://bybox.atlassian.net/browse/THIN-6109 
    // if you do this ticket or the ticket has been done then remove this comment
    const nssMaterialNumberRequired = false;

    const setPreAlertComponentItems = (preAlertItems: PreAlertItem[]): PreAlertComponentItem[] => {
        if (!preAlertItems) {
            return [
                {
                    preAlertItem: defaultPreAlert,
                    isValid: false,
                },
            ];
        }

        return preAlertItems.map((preAlertItem) => {
            return {
                preAlertItem: preAlertItem,
                isValid: true,
            };
        });
    };

    const { heading, blurb, addButtonLabel } = localisations.createPreAlert.stages.selectItems;
    const { handleFieldChange, onDisableNextButton } = props;
    const [preAlertComponents, setPreAlertComponents] = useState<PreAlertComponentItem[]>(
        setPreAlertComponentItems(props.fields.items)
    );

    useEffect(() => {
        const preAlertItems = preAlertComponents.map((x) => x.preAlertItem);
        handleFieldChange({ items: preAlertItems });
    }, [preAlertComponents, handleFieldChange]);

    useEffect(() => {
        onDisableNextButton?.(!preAlertComponents.every((m: PreAlertComponentItem) => m.isValid === true));
    }, [preAlertComponents, onDisableNextButton]);

    const addPreAlertItem = () => {
        setPreAlertComponents((items) => [...items, { isValid: false, preAlertItem: defaultPreAlert }]);
    };

    const changePreAlertItem = useCallback(
        (index: number, item: PreAlertItem, isValid: boolean) => {
            setPreAlertComponents((items) => {
                items[index] = { isValid: isValid, preAlertItem: item };
                return [...items];
            });
        },
        [setPreAlertComponents]
    );

    const deletePreAlertItem = useCallback(
        (removeIndex: number) => {
            setPreAlertComponents((items) => {
                items.splice(removeIndex, 1);
                return [...items];
            });
        },
        [setPreAlertComponents]
    );

    return (
        <>
            <Typography variant="h5" gutterBottom>
                {heading}
            </Typography>

            <Typography variant="body1" gutterBottom>
                {blurb}
            </Typography>

            <Button onClick={addPreAlertItem} color="primary" variant="contained">
                {addButtonLabel}
                <AddCircleOutline />
            </Button>

            {preAlertComponents.map((item, index) => (
                <PreAlertItemComponent
                    nssMaterialNumberRequired={nssMaterialNumberRequired}
                    index={index}
                    fieldCompanyId={props.fieldCompanyId}
                    initialItem={item.preAlertItem}
                    onDelete={preAlertComponents.length === 1 ? undefined : deletePreAlertItem}
                    onChange={changePreAlertItem}
                    key={"pa-item-container-" + index.toString()}
                />
            ))}
            <Button onClick={addPreAlertItem} color="primary" variant="contained">
                {addButtonLabel}
                <AddCircleOutline />
            </Button>
        </>
    );
}

export default SelectItemsStage;
